import { ref, computed } from '@vue/composition-api';
import _ from 'lodash';

type stfuTs = {
  [key: string]: any;
};

export const useDetails = (props: any, ctx: any) => {
  // Computed
  const type = computed(() => {
    return _.get(props.payload, '_source.type', 'undefined');
  });
  const reference = computed(() => {
    return _.get(props.payload, '_source.reference', 'undefined');
  });
  const model = computed(() => {
    return _.get(props.payload, '_source.model', 'undefined');
  });
  const measures = computed(() => {
    return Object.entries(_.get(props.payload, '_source.measures', []));
  });
  const editableInfos = computed(() => {
    return [
      {
        label: 'Type',
        key: 'type',
        value: type.value
      },
      {
        label: 'Model',
        key: 'model',
        value: model.value
      },
      {
        label: 'Reference',
        key: 'reference',
        value: reference.value
      }
    ];
  });

  // Data
  let editingInfos = ref(false);
  let editingMetadata = ref(false);
  let editedInfos: stfuTs = ref({});
  let metadataFormSchema = ref({});
  let metadata = ref({});
  let metadataFields = ref({});

  //Methods
  const onConfirmLink = (devices: any, modalId: String) => {
    ctx.root.$nextTick(() => {
      ctx.root.$bvModal.hide(modalId);
    });
    ctx.emit('link', devices);
  };
  const resetEditedInfos = () => {
    editedInfos.value = {
      model: model.value,
      type: type.value,
      reference: reference.value
    };
  };
  const get = (key: String) => {
    return _.get(props.payload, `_source.metadata.${key}`, 'N/A');
  };
  const getMeasureValue = (type: String, payload: any) => {
    switch (type) {
      case 'position': {
        const coord = _.get(payload, 'point', 'N/A');
        return { ...coord, label: `lat: ${coord.lat} lon: ${coord.lon}` };
      }
      case 'movement': {
        const movement = _.get(payload, 'moving', 'N/A');
        return { ...movement, label: `moving: ${movement}` };
      }
      case 'temperature': {
        const temperature = _.get(payload, 'degree', 'N/A');
        return { ...temperature, label: temperature };
      }
      default: {
        console.log(type, payload);
        return { ..._.get(payload, type as string, 'N/A'), label: type };
      }
    }
  };
  const unlink = (deviceId: String) => {
    ctx.emit('unlink', deviceId);
  };
  const link = (modalId: String) => {
    ctx.root.$bvModal.show(modalId);
  };
  const onValueChanged = (value: any, type: string) => {
    editedInfos.value[type] = value;
  };
  const saveInfos = () => {
    editingInfos.value = false;
    ctx.emit('saveInfos', editedInfos.value);
  };
  const resetInfos = () => {
    resetEditedInfos();
    editingInfos.value = false;
  };
  const saveMetadata = () => {
    editingMetadata.value = false;
    ctx.emit('saveMetadata', metadata.value);
  };
  const resetMetadata = () => {
    editingMetadata.value = false;
  };
  const formatMetaLabel = (label: String) => {
    const formattedLabel = `${label}:`;
    return formattedLabel.charAt(0).toUpperCase() + formattedLabel.slice(1);
  };

  return {
    editingInfos,
    editingMetadata,
    editedInfos,
    metadataFormSchema,
    metadata,
    metadataFields,
    type,
    reference,
    model,
    measures,
    editableInfos,
    onConfirmLink,
    resetEditedInfos,
    get,
    getMeasureValue,
    unlink,
    link,
    onValueChanged,
    saveInfos,
    resetInfos,
    saveMetadata,
    resetMetadata,
    formatMetaLabel
  };
};
